<template>
    <tr class="expanded-row">
        <td colspan="12">
            <ExpandedRequest v-if="cpRequests" :data="data" :set-request-data = "setExpandedData"/>
            <ExpandedUpdate 
                v-else 
                :data="data"
                :expand-loading = "expandLoading"
                @setPartnerUpdates = "setExpandedData"
            />
            <!-- <Loader v-if="expandLoading"/> -->
        </td>
    </tr>
</template>

<script>
import Icon from '@/components/Theme/Icon'
import ExpandedRequest from './ExpandedRequest'
import ExpandedUpdate from './ExpandedUpdate'
import { watch } from '@vue/composition-api'
import {Loader} from '../../../../../components/Icons'

export default {
    name: 'ExpandedRow',
    props: {
        data: Object,
        setExpandedData: Function,
        expandLoading: Boolean
    },
    components: {
        Icon,
        ExpandedRequest,
        ExpandedUpdate,
        Loader
    },
    computed: {
        cpRequests() {
            return this.$route.name === 'requests'
        }
    }
}
</script>

<style lang="scss" scoped>
tr.expanded-row {
    background: #F7F7FE;
    cursor: default;
}

</style>


